import MobileMenu from "./MobileMenu.vue";

export default MobileMenu;
